import React, { memo } from 'react'
import { shape, func, number, string } from 'prop-types'

import { Aim } from '@assets/icons'
import Button from './CenterButton.style'

function CenterButton({ map, position, icon }) {
  const onClick = () => {
    map.setCenter(position)
  }

  return (
    <Button onClick={onClick}>
      <img src={icon || Aim} alt="Centralize map" />
    </Button>
  )
}

CenterButton.propTypes = {
  map: shape({
    setCenter: func,
  }),
  position: shape({
    lat: number,
    lng: number,
  }).isRequired,
  icon: string,
}

CenterButton.defaultProps = {
  map: null,
  icon: '',
}

export default memo(CenterButton)
